/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { RepatriationOpportunityGroupSummaryResource } from './';
import {
    RepatriationOpportunityGroupSummaryResourceFromJSON,
    RepatriationOpportunityGroupSummaryResourceFromJSONTyped,
    RepatriationOpportunityGroupSummaryResourceToJSON,
} from './';
import type { RepatriationOpportunityResource } from './';
import {
    RepatriationOpportunityResourceFromJSON,
    RepatriationOpportunityResourceFromJSONTyped,
    RepatriationOpportunityResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface RepatriationOpportunityGroupResource
 */
export interface RepatriationOpportunityGroupResource {
    /**
     * 
     * @type {RepatriationOpportunityGroupSummaryResource}
     * @memberof RepatriationOpportunityGroupResource
     */
    summary: RepatriationOpportunityGroupSummaryResource;
    /**
     * 
     * @type {Array<RepatriationOpportunityResource>}
     * @memberof RepatriationOpportunityGroupResource
     */
    opportunities: Array<RepatriationOpportunityResource>;
}

/**
 * Check if a given object implements the RepatriationOpportunityGroupResource interface.
 */
export function instanceOfRepatriationOpportunityGroupResource(value: object): value is RepatriationOpportunityGroupResource {
    if (!('summary' in value) || value['summary'] === undefined) return false;
    if (!('opportunities' in value) || value['opportunities'] === undefined) return false;
    return true;
}

export function RepatriationOpportunityGroupResourceFromJSON(json: any): RepatriationOpportunityGroupResource {
    return RepatriationOpportunityGroupResourceFromJSONTyped(json, false);
}

export function RepatriationOpportunityGroupResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepatriationOpportunityGroupResource {
    if (json == null) {
        return json;
    }
    return {
        
        'summary': RepatriationOpportunityGroupSummaryResourceFromJSON(json['summary']),
        'opportunities': ((json['opportunities'] as Array<any>).map(RepatriationOpportunityResourceFromJSON)),
    };
}

export function RepatriationOpportunityGroupResourceToJSON(value?: RepatriationOpportunityGroupResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'summary': RepatriationOpportunityGroupSummaryResourceToJSON(value['summary']),
        'opportunities': ((value['opportunities'] as Array<any>).map((v) => RepatriationOpportunityResourceToJSON(v))),
    };
}

